import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { NgbModalConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApisService } from '../../../shared/service/api.service';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-event-booking',
  template: '<signature-pad #signature [options]="signaturePadOptions" (drawStart)="drawStart($event)" (drawEnd)="drawComplete($event)"></signature-pad>',
  templateUrl: './event-booking.component.html',
  styleUrls: ['./event-booking.component.scss']
})
export class EventBookingComponent implements OnInit {
  @ViewChild('content') content: ElementRef;
  registrationForm: FormGroup;
  notif: any = '';

  categories = [
  {
    label: 'Retail Force (Resellers)',
    value: 'Retail Force',
    fee: '₱5,000 P/A',
    description: 'Entrepreneurs and businesses actively selling products at the retail level.',
  },
  {
    label: 'Rising Ventures (Startups)',
    value: 'Rising Ventures',
    fee: '₱5,000 P/A',
    description: 'Young businesses (max 2 years old with less than ₱3M capitalization) aiming for rapid growth.',
  },
  {
    label: 'Provincial Partners (Provincial Distributors)',
    value: 'Provincial Partners',
    fee: '₱10,000 P/A',
    description: 'Essential links in the supply chain, ensuring local market penetration and accessibility.',
  },
  {
    label: 'Regional Champions (Regional Distributors)',
    value: 'Regional Champions',
    fee: '₱25,000 P/A',
    description: 'Key players managing distribution at the regional level, ensuring broad market reach.',
  },
  {
    label: 'Brand Innovators (Brand Owners)',
    value: 'Brand Innovators',
    fee: '₱30,000 P/A',
    description: 'Owners of established brands driving innovation and market leadership.',
  },
  {
    label: 'Pioneering Circle (Founding Members)',
    value: 'Pioneering Circle',
    fee: '₱50,000 P/A',
    description: 'The visionaries and leaders who established the organization and continue to shape its direction.',
  },
  {
    label: 'Corporate Pillars (Large Companies Stakeholder with Capitalization of ₱100M+)',
    value: 'Corporate Pillars',
    fee: '₱50,000 P/A',
    description: 'Industry giants and corporations supporting the ecosystem’s growth.',
  },
  {
    label: 'Growth Enablers (SMEs ₱3M to ₱100M Capitalization)',
    value: 'Growth Enablers',
    fee: '₱50,000 P/A',
    description: 'SMEs contributing to economic growth and industry innovation.',
  },
  {
    label: 'Honorary Circle (Honorary Members)',
    value: 'Honorary Circle',
    fee: 'Waived to be granted by the BOD.',
    description: 'Distinguished individuals recognized for their contributions and advocacy in the industry.',
    waived: true
  }
];


  constructor(
    private api: ApisService,
    private config: NgbModalConfig,
    private modal: NgbModal,
    private fb: FormBuilder
  ) { 
    config.backdrop = 'static';
		config.keyboard = false;

    this.registrationForm = this.fb.group({
      fullName: ['', Validators.required],
      contact: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      address: ['', Validators.required],
      barangay: ['', Validators.required],
      city: ['', Validators.required],
      province: ['', Validators.required],
      country: ['', Validators.required],
      agency: [''],
      productDescription: ['', Validators.required],
      designation: ['', Validators.required],
      categories: this.fb.array([], [Validators.required, Validators.minLength(1)]),
      assistantName: ['', Validators.required],
      assistantContact: ['', Validators.required],
      assistantEmail: ['', [Validators.required, Validators.email]],
      consent: [false, Validators.requiredTrue]
    });
  }

  ngOnInit() {
  }

  get categoriesArray(): FormArray {
    return this.registrationForm.get('categories') as FormArray;
  }

  onCategoryChange(value: string, checked: boolean): void {
    const categories = this.categoriesArray;
    if (checked) {
      categories.push(this.fb.control(value));
    } else {
      const index = categories.controls.findIndex(ctrl => ctrl.value === value);
      if (index !== -1) {
        categories.removeAt(index);
      }
    }
    categories.markAsTouched();
  }

  onSubmit() {
    if (this.registrationForm.invalid) {
      this.registrationForm.markAllAsTouched();
      this.showWarning('Please complete all required fields and accept the consent.');
      return;
    }

    this.api.posts('/api/v1/events/register', this.registrationForm.value).then((res: any) => {
      if(!res.uuid) {
        this.showWarning('Registration failed. Please review the form fields and ensure all required information is correct.');
      return;  // Stop further execution
      }
      
      this.showGreeting( 'Your submission is now being processed. Our account managers will contact you via email or phone for further verification. Please keep a copy of your reference code: {' + res.uuid + '} for your records.');
      this.registrationForm.reset();
    }).catch(error => {
      this.showWarning('Something went wrong, contact technical support.');
      console.log('error', error);
    });
  }

  showGreeting(message: any) {
    this.notif = message;
    this.modal.open(this.content, {centered: true});
  }

  showWarning(message: any) {
    this.notif = message;
    this.modal.open(this.content, {centered: true});
  }
}
